import moment from "moment";

class schedules {
  constructor(groupId, id, from, to, segmId, seqNum, segmDespl, name) {
    this.groupId = groupId;
    this.id = id;
    this.from = moment(from).utc().format("DD-MM-YYYY");
    this.to = to == null ? "" : moment.utc(to).format("DD-MM-YYYY");
    this.segmId = segmId;
    this.seqNum = seqNum;
    this.segmDespl = segmDespl;
    this.name = name;
  }
  get dateTo() {
    return this.to !== null;
  }

  static fromJson({
    grupoId,
    horarioId,
    fecDesde,
    fecHasta,
    segmId,
    numSecuencia,
    segmDespl,
    nomHorario,
  }) {
    return new schedules(
      grupoId,
      horarioId,
      fecDesde,
      fecHasta,
      segmId,
      numSecuencia,
      segmDespl,
      nomHorario
    );
  }
}

export default schedules;
